// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__3QWRa","visibleHandle":"Handle_visibleHandle__1iv9Y","dragged":"Handle_dragged__2RtQJ"};